'use client';
import PageLayout from "../PageLayout";
import { useTranslation } from "react-i18next";
import { defaultLang, SUPPORTED } from "../../config/languages";
import { useParams } from 'next/navigation';
import BlogLayout2 from "./Layout2";

export default function Blog() {
  const { t } = useTranslation(['blog']);
  const { lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;

  return (
    <PageLayout
      presentLikeHome
      title={t('blog:pageTitle')}
      metaDescription={t('blog:pageMetaDescription')}
      canonical={`https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/blog`}
    >
      <BlogLayout2 />
    </PageLayout>
  );
}
